import CommentIcon from '@mui/icons-material/Comment'
import MarkUnreadChatAltIcon from '@mui/icons-material/MarkUnreadChatAlt'
import WarningIcon from '@mui/icons-material/Warning'
import { IconButton, Tooltip } from '@mui/material'
import React, { useEffect, useState } from 'react'
import ADRCertificate from '../../../../../shared/common-utilities/Qualifications/ADRCertificate'
import Compartments from '../../../../../shared/common-utilities/Qualifications/Compartments'
import DefaultQualificationIcon from '../../../../../shared/common-utilities/Qualifications/DefaultQualificationIcon'
import Huckepack from '../../../../../shared/common-utilities/Qualifications/Huckepack'
import MountedForklift from '../../../../../shared/common-utilities/Qualifications/MountedForklift'
import OpenRoof from '../../../../../shared/common-utilities/Qualifications/OpenRoof'
import RoalerBed from '../../../../../shared/common-utilities/Qualifications/RoalerBed'
import SteeringrRearAxle from '../../../../../shared/common-utilities/Qualifications/SteeringrRearAxle'
import TailLift from '../../../../../shared/common-utilities/Qualifications/TailLift'
import BoxTrailer from '../../../../../shared/common-utilities/Trailer/BoxTrailer'
import ChassisTrailer from '../../../../../shared/common-utilities/Trailer/ChassisTrailer'
import FlatbedOpenTrailer from '../../../../../shared/common-utilities/Trailer/FlatbedOpenTrailer'
import TankTrailer from '../../../../../shared/common-utilities/Trailer/TankTrailer'
import { CommonConst } from '../../../../../shared/common-utilities/enums/CommonConst'
import EquipmentHeavy from './../../../../../shared/common-utilities/Qualifications/EquipmentHeavy'
import LongHeavyCertificate from './../../../../../shared/common-utilities/Qualifications/LongHeavyCertificate'
import TemperatureLow from './../../../../../shared/common-utilities/Qualifications/TemperatureLow'
import VCACertificate from './../../../../../shared/common-utilities/Qualifications/VCACertificate'
import Ecocombi from './../../../../../shared/common-utilities/Trailer/Ecocombi'

const qualificationIcons = {
    _x0020_: DefaultQualificationIcon,
    TAILLIFT: TailLift,
    ROALERBED: RoalerBed,
    STEERAXLE: SteeringrRearAxle,
    TRMF: MountedForklift,
    COOLINGE: TemperatureLow,
    COMPARTM: Compartments,
    ADR: ADRCertificate,
    HUCKEPACK: Huckepack,
    OPENROOF: OpenRoof,
    VCACERTI: VCACertificate,
    LHVCERTI: LongHeavyCertificate,
    LHVEQUIP: EquipmentHeavy,
};

export const TrailerResource = (props) => {
    const { resource, handleEventHoverIn, handleEventHoverOut, toggleOpenMail, openMail, handleDragStart, nvtTrailerType, nvtQualificationType } = props
    const [trailer, setTrailer] = useState({})
    useEffect(() => {
        if (resource?.trailers?.length > 0) {
            let trailer = resource.trailers[0]
            trailer.trailerTypeEnum2 = nvtTrailerType?.find(e => e.name == trailer.trailerTypeEnum)
            setTrailer(trailer)
        }
    }, [resource])
    const getTrailorIcon = () => {
        if (trailer.trailerTypeEnum == "TANK")
            return <TankTrailer height="35" width="70" />
        else if ((resource.resourceType == CommonConst.CHASSIS || trailer.trailerTypeEnum == "CHAS"))
            return <ChassisTrailer height="35" width="80" />
        else if (trailer.trailerTypeEnum == "BOX")
            return <BoxTrailer height="35" width="70" />
        else if (trailer.trailerTypeEnum == "FLAT")
            return <FlatbedOpenTrailer height="25" />
        else if (trailer.trailerTypeEnum == "ECOC")
            return <Ecocombi height="25" />
        else
            return <BoxTrailer height="30" />
    }

    const renderQualificationIcons = (resourceQualifications) => {
        return resourceQualifications?.map((qualification) => {
            const caption = qualification.description;
            const IconComponent = qualificationIcons[qualification.typeQualification];

            if (!IconComponent) {
                return null;
            }

            return (
                <div>
                    <Tooltip key={caption} title={caption}>
                        <IconButton sx={{ p: 0 }}><IconComponent height="20" /></IconButton>
                    </Tooltip>
                </div>
            );
        });
    };

    return (
        <>
            <div className='d-flex align-items-center relative' style={{ gap: '5px', justifyContent: 'end' }} >
                <div style={{ pointerEvents: 'none', display: 'inline-flex', justifyContent: 'end' }} className='vh-text' >
                    <div style={{ minWidth: '88px', }}>
                        <div style={{display:'inline-flex', position:'relative'}}>
                        {/* <div className='vh-number wflex resource-number'> */}
                        <div className=' resource-number'>
                            {resource.resourceNo}
                        </div>
                        {getTrailorIcon()}
                        </div>
                    </div>
                </div>
                {/* <BoxTrailer height="35" width="70" />
                {resource.id[0] == "v" && <>
                    {(resource.id == "v7" || resource.id == "v9") ?
                        <Semitrailer2 height="30" width="60" /> : <BoxTrailer height="30" width="60" />}
                </>}
                {resource.id[0] == "s" && <TankTrailer height="35" width="70" />}
                {resource.id[0] == "t" && <ChassisTrailer height="35" width="70" />} */}
                {/* <div className='resource-number '> */}

                {trailer?.resourceQualifications?.length > 0 && <div className='qualifications-block'>
                    {renderQualificationIcons(trailer.resourceQualifications)}
                </div>}
            </div>
            <div className='mt0'>
                <div
                // onMouseEnter={e => handleEventHoverIn(e, "LicenseHover", resource)} onMouseLeave={handleEventHoverOut}
                >
                    <Tooltip width="600" title={resource?.countryCode?.toUpperCase()}>
                        <span className={'number-plate sm ' + (trailer?.countryRegion?.toLowerCase() || 'nl')} draggable onDragStart={e => handleDragStart(e, "Resource", resource)}>
                            {trailer?.numberplate || ''}
                        </span>
                    </Tooltip>
                </div>
                <div style={{ margin: "0 5px", display: 'flex', gap: 3, alignItems: 'center' }} >
                    {/* <i className="icon" style={{ height: '20px' }} >
                        {openMail.resource == resource.name && openMail.isOpened ? <CommentIcon color='primary' fontSize="small" onClick={e => toggleOpenMail({ resource: resource.name, isOpened: false })} /> : <MarkUnreadChatAltIcon color='primary' fontSize="small" onClick={e => toggleOpenMail({ resource: resource.name, isOpened: true })} />}
                    </i>
                    <WarningIcon color='warning' fontSize="small" /> */}
                </div>
            </div>
        </>
    )
}
